export interface BotSource {
  id: string;
  name: string;
  badgeColor: string;
  enabled: boolean;
  locked: boolean;
  description: string;
}

export type CommunicationStyle = "friendly" | "professional" | "enthusiastic" | "concise";

export interface BotConfig {
  botName: string;
  botRole: string;
  companyName: string;
  style: CommunicationStyle;
  emojiEnabled: boolean;
  primaryLanguage: string;
  autoDetectLanguage: boolean;
  masterEnabled: boolean;
}

export const botSources: BotSource[] = [
  { id: "indiamart", name: "IndiaMart", badgeColor: "bg-orange-50 text-orange-700 border-orange-200", enabled: true, locked: false, description: "High volume — strongly recommended" },
  { id: "justdial", name: "JustDial", badgeColor: "bg-blue-50 text-blue-700 border-blue-200", enabled: true, locked: false, description: "High volume — strongly recommended" },
  { id: "tradeindia", name: "TradeIndia", badgeColor: "bg-red-50 text-red-600 border-red-200", enabled: false, locked: false, description: "Lower volume — optional" },
  { id: "website", name: "Website Forms", badgeColor: "bg-purple-50 text-purple-700 border-purple-200", enabled: true, locked: false, description: "Website inquiries respond well" },
  { id: "social", name: "Social Media", badgeColor: "bg-pink-50 text-pink-700 border-pink-200", enabled: false, locked: false, description: "Variable quality — test first" },
  { id: "manual", name: "Manual Entry", badgeColor: "bg-gray-100 text-gray-600 border-gray-200", enabled: false, locked: true, description: "Manual leads skip bot and go directly to assignment rules" },
];

export const defaultBotConfig: BotConfig = {
  botName: "Aria",
  botRole: "Sales Assistant",
  companyName: "PropMax Solutions",
  style: "friendly",
  emojiEnabled: true,
  primaryLanguage: "English",
  autoDetectLanguage: false,
  masterEnabled: false,
};

export const communicationStyles: { id: CommunicationStyle; label: string; description: string; preview: string }[] = [
  {
    id: "friendly",
    label: "Friendly & Casual",
    description: "Warm, approachable tone",
    preview: "Hi! 👋 Thanks for reaching out. Are you still interested?",
  },
  {
    id: "professional",
    label: "Professional & Formal",
    description: "Polished, business-like tone",
    preview: "Good day. Thank you for your inquiry. Are you still interested?",
  },
  {
    id: "enthusiastic",
    label: "Enthusiastic & Energetic",
    description: "Exciting, high-energy tone",
    preview: "Wow! Great timing! 🎉 We have amazing options for you! Still interested?",
  },
  {
    id: "concise",
    label: "Concise & Direct",
    description: "Quick, to-the-point tone",
    preview: "Hi. Interested in property? Reply 1=Yes 2=No 3=Call me.",
  },
];

export const languageOptions: string[] = ["English", "Hindi", "Hinglish (English + Hindi mix)", "Marathi", "Gujarati", "Tamil", "Telugu"];

export const botStats = {
  engaged: 298,
  qualified: 201,
  notInterested: 43,
  noReply: 54,
};